import Axios from '../api';
import { Pagination } from '@/_types/pagination';



class EtablissementService
{
    path: string;

    constructor(){
        this.path = '/etablissements';
    }

    async getEtablissements(page = 1): Promise<Pagination>{
        return await Axios.get(`${this.path}?page=${page}`);
    }

    async searchEtablissement(search: string, page = 1): Promise<Pagination> {
        return await Axios.get(`${this.path}?page=${page}&search=${search}`);
    }
}

export default new EtablissementService();